import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/swiper-bundle.css';

export default function (element, data) {
  const swiperElement = element.querySelector(".swiper-categories");
    const swiperOptions = {
        modules: [Navigation],
        slidesPerView: 'auto',
        spaceBetween: 10,
        //watchOverflow: true,
        // slidesOffsetBefore: 20,
        //slidesOffsetAfter: 20,
        // breakpoints: {
        //     992: {
        //         // slidesOffsetBefore: 37,
        //     },
        // }
        navigation: {
            prevEl: element.querySelector(".catalog-nav_prev"),
            nextEl: element.querySelector(".catalog-nav_next"),
        },
    };

    const updateEdges = (swiper) => {
        // когда контент влезает целиком, swiper залочен и isEnd врёт — считаем, что мы у обоих краёв
        swiperElement.classList.toggle("is-start", swiper.isLocked || swiper.isBeginning);
        swiperElement.classList.toggle("is-end", swiper.isLocked || swiper.isEnd);
    };

    swiperOptions.on = {
        init: updateEdges,
        // после перерасчёта размеров позиции краёв могут поменяться
        resize: updateEdges,
        setTranslate: updateEdges,
    };

    element.swiper = new Swiper(swiperElement, swiperOptions);
};
